/**
 * Plugin Vue que expõe `this.$isDesktop` e `this.$electron` globalmente.
 *
 * - `this.$isDesktop` → true quando rodando dentro do Electron
 * - `this.$electron`  → referência a window.electronAPI (ou null no modo web)
 *
 * Uso:
 *   import DesktopPlugin from '@/plugins/desktop';
 *   Vue.use(DesktopPlugin);
 */

const DesktopPlugin = {
  install(Vue) {
    const isDesktop =
      typeof window !== "undefined" &&
      window.electronAPI !== undefined &&
      window.electronAPI.isDesktop === true;

    Vue.prototype.$isDesktop = isDesktop;
    Vue.prototype.$electron = isDesktop ? window.electronAPI : null;

    // Disponibiliza também via Vue.observable para uso em Vuex/composables
    Vue.$isDesktop = isDesktop;
    Vue.$electron = isDesktop ? window.electronAPI : null;
  },
};

export default DesktopPlugin;

/**
 * Helper para usar fora de componentes Vue (ex.: services, adapters).
 */
export function isDesktopMode() {
  return (
    typeof window !== "undefined" &&
    window.electronAPI !== undefined &&
    window.electronAPI.isDesktop === true
  );
}

export function getElectronAPI() {
  return isDesktopMode() ? window.electronAPI : null;
}
